import { createSlice } from '@reduxjs/toolkit';

import { IHelpCenterCategory, IHelpCenterTopic } from '../types/helpCenter';
import { SUPPORT_VOTED_TOPICS } from '../../constants/knowledgeBase';

interface IHelpCenterState {
  categories: IHelpCenterCategory[];
  topics: { [key: string]: IHelpCenterTopic[] };
  voted: string[];
  loading: { [key: string]: boolean };
}

const initialState = {
  categories: [],
  topics: {},
  voted: JSON.parse(localStorage.getItem(SUPPORT_VOTED_TOPICS)) || [],
  loading: {
    categories: false,
    topics: false,
  },
} as IHelpCenterState;

export const helpCenterSlice = createSlice({
  name: 'helpCenter',
  initialState,
  reducers: {
    setCategories: (state: IHelpCenterState, action) => ({
      ...state,
      categories: action.payload,
    }),
    setTopics: (state: IHelpCenterState, action) => ({
      ...state,
      topics: action.payload,
    }),
    updateTopic: (state: IHelpCenterState, action) => ({
      ...state,
      topics: {
        ...state.topics,
        [action.payload.categorySlug]: state.topics[action.payload.categorySlug].map((el) =>
          el.id !== action.payload.id ? el : { ...el, ...action.payload },
        ),
      },
    }),
    voteTopic: (state: IHelpCenterState, action) => ({
      ...state,
      voted: [...state.voted, action.payload],
    }),
    setCategoriesLoading: (state: IHelpCenterState, action) => {
      // eslint-disable-next-line no-param-reassign
      state.loading.categories = action.payload;
    },
    setTopicsLoading: (state: IHelpCenterState, action) => {
      // eslint-disable-next-line no-param-reassign
      state.loading.topics = action.payload;
    },
  },
});

export const {
  setCategories,
  setTopics,
  updateTopic,
  voteTopic,
  setCategoriesLoading,
  setTopicsLoading,
} = helpCenterSlice.actions;

export default helpCenterSlice.reducer;
